"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const Configuration_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/Configuration"));
const exception2alert_1 = __importDefault(require("@common/tsutils/exception2alert"));
let ConfigModal = class ConfigModal extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.name = '';
        this.shared = false;
        this.hasAlchemy = false;
        this.showModal = this.triggerModal;
    }
    onChangetriggerModal() {
        if (this.triggerModal) {
            this.showModal = this.triggerModal;
            this.onShow();
        }
    }
    closeModal() {
        this.showModal = false;
        this.$emit('onconfigmodalclose');
    }
    onShow() {
        this.hasAlchemy = this.heatmap.hasAlchemy();
    }
    get disabled() {
        return this.hasAlchemy;
    }
    async saveConfig() {
        if (this.disabled) {
            return;
        }
        const config = this.heatmap.toConfiguration();
        try {
            await Configuration_1.default.saveNew(this.name, this.shared, config);
            this.closeModal();
        }
        catch (e) {
            (0, exception2alert_1.default)(e);
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ConfigModal.prototype, "heatmap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ConfigModal.prototype, "triggerModal", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('triggerModal')
], ConfigModal.prototype, "onChangetriggerModal", null);
ConfigModal = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {}
    })
], ConfigModal);
exports.default = ConfigModal;
